export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-3xl font-bold mb-4 tracking-wider" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              KRISPY KUTZ INC
            </h3>
            <p className="text-gray-400 mb-6">
              Premium grooming services for the modern gentleman. Experience excellence in every cut.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('team')} className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Our Team
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">Classic Haircut</li>
              <li className="text-gray-400">Hot Towel Shave</li>
              <li className="text-gray-400">Beard Grooming</li>
              <li className="text-gray-400">Hair Coloring</li>
              <li className="text-gray-400">Facial Treatment</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact Info</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span>6111 FM 1960 Rd W<br />Suite 207 E<br />Houston, TX 77069</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                <span>(832) 287-5144</span>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                <span>info@barbershop.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 Premium Barbershop. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 text-sm">
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
              Powered by Readdy
            </a>
            <span className="text-gray-600">|</span>
            <button className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
              Privacy Policy
            </button>
            <button className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
